(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationGetInsuranceQuotes',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var label_name            = 'reservationgetinsurancequotes';
		var rental_cost_field     = $('#' + label_name + '-components-rental-cost');
		var other_cost_field      = $('#' + label_name + '-components-other-cost');
		var total_trip_field      = $('#' + label_name + '-trip_cost');
		var total_rental_field    = $('#' + label_name + '-rental-default-trip_cost');
		var total_trip_cost       = 0;
		var prev_other_cost_value = 0;

		updateTotalTripCostValue();

		// travel component checkbox (cruise, air etc. etc)
		$('.include-component').change(function includeComponent()
		{
			var component_index = $(this).data('index');
			var component_type  = $(this).data('type');
			var component_price = $(this).parent().parent()
										 .find('.component-cost')
										 .html().trim()
										 .replace(/[$,]/g, '');

			component_price = parseFloat(component_price);

			if (isNaN(component_price) === true) {
				component_price = 0;
			}

			// if car, show it's form and change the
			// car rental cost input field and coverage dates instead
			if (component_type.indexOf('car') !== -1) {
				$('.' + component_index).toggleClass('hidden');
				$('#' + label_name + '-rental-' + component_index + '-trip_cost')
					.val(component_price.toFixed(2));
				$('#' + label_name + '-rental-' + component_index + '-start_date')
					.data('DateTimePicker').date(moment($(this).data('start')));
				$('#' + label_name + '-rental-' + component_index + '-end_date')
					.data('DateTimePicker').date(moment($(this).data('end')));
				return;
			}

			if ($(this).is(':checked')) {
				total_trip_cost += component_price;
			} else {
				total_trip_cost -= component_price;
			}

			updateTotalTripCostValue();

			adjustCoverageDates($(this));
		});

		// default car rental cost checkbox
		$('#' + label_name + '-components-rental-include').change(function onRentalChange()
		{
			$('.car-rental').toggleClass('hidden');

			if ($(this).is(':checked')) {
				rental_cost_field.removeAttr('disabled');
			} else {
				rental_cost_field.val('');
				rental_cost_field.attr('disabled', 'disabled');
			}
		});

		// miscellaneous checkbox
		$('#' + label_name + '-components-other-include').change(function onOtherChange()
		{
			var other_cost_value = parseFloat(other_cost_field.val());

			if ($(this).is(':checked')) {
				other_cost_field.removeAttr('disabled');
			} else {
				other_cost_field.val('');
				other_cost_field.attr('disabled', 'disabled');

				if (other_cost_value) {
					total_trip_cost -= other_cost_value;
					prev_other_cost_value = 0;
					updateTotalTripCostValue();
				}
			}
		});

		// when the select dropdown of addresses change
		$('#' + label_name + '-available_addresses').change(function onAddressChange()
		{
			var address_id = $(this).val();

			if (address_id) {
				Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id).then(function onAddressSuccess(address)
				{
					Adzuki.Ajax.get('/States/getByCountryId/' + address.country_id).then(function onStatesSuccess(states)
					{
						populateStates(states);

						$('#' + label_name + '-state_id').val(address.state_id);
					});

					// country cannot be Canada (temporary until we are able to quote for Canada)
					if (parseInt(address.country_id) === 31) {
						$('#' + label_name + '-origination_country_id').parents('.form-group').addClass('has-error');

						Adzuki.StatusMessage('error', 'Canada is not currently supported for quoting insurance');
					}

					$('#' + label_name + '-address1').val(address.address1);
					$('#' + label_name + '-address2').val(address.address2);
					$('#' + label_name + '-city').val(address.city);
					$('#' + label_name + '-zip').val(address.zip);
					$('#' + label_name + '-origination_country_id').val(address.country_id);
				});
			}
		});

		// when the select drop down of origination country changes
		$('#' + label_name + '-origination_country_id').change(function onCountryChange()
		{
			var country_id = parseInt($(this).val());

			// country cannot be Canada (temporary until we are able to quote for Canada)
			if (country_id === 31) {
				$('#' + label_name + '-origination_country_id').parents('.form-group').addClass('has-error');

				Adzuki.StatusMessage('error', 'Canada is not currently supported for quoting insurance');
			}

			Adzuki.Ajax.get('/States/getByCountryId/' + country_id).then(function onStatesSuccess(states)
			{
				populateStates(states);
			});
		});

		// clearing the address
		$('#clear-address').click(function onClearAddressClick(event)
		{
			event.preventDefault();

			$('#' + label_name + '-address1').val('');
			$('#' + label_name + '-address2').val('');
			$('#' + label_name + '-state_id').val('');
			$('#' + label_name + '-city').val('');
			$('#' + label_name + '-zip').val('');
			$('#' + label_name + '-available_addresses').val('');
		});

		// update total trip cost when there's a value on "Miscellaneous" price
		other_cost_field.blur(function onOtherCostBlur()
		{
			var other_cost_value = parseFloat($(this).val());

			if (isNaN(other_cost_value) === true) {
				other_cost_value = 0;
			}

			if (prev_other_cost_value && prev_other_cost_value > 0) {
				total_trip_cost -= prev_other_cost_value;
			}

			if (other_cost_value) {
				total_trip_cost += other_cost_value;
			}

			updateTotalTripCostValue();

			prev_other_cost_value = other_cost_value;
		});

		// update total car rental cost when there's a value on "Rental Car Cost" price
		rental_cost_field.blur(function onRentalCostBlur()
		{
			total_rental_field.val($(this).val());
		});

		// when changing coverage start date,
		// adjust the coverage end date only if the new start date is after the end date
		$('#' + label_name + '-start_date').on('dp.change', function onStartDateChange(event)
		{
			var start_date = event.date;
			var end_date   = $('#' + label_name + '-end_date');

			if (start_date) {
				if (end_date.data('DateTimePicker').date() === null || start_date.isAfter(end_date.data('DateTimePicker').date())) {
					end_date.data('DateTimePicker').date(start_date.add(1, 'd'));
				}
			}
		});

		// when changing car rental coverage start date,
		// adjust the car rental coverage end date only
		// if the new start date is after the end date
		$('#' + label_name + '-rental-default-start_date').on('dp.change', function onRentalStartDateChange(event)
		{
			var rental_start_date = event.date;
			var rental_end_date   = $('#' + label_name + '-rental-default-end_date');

			if (rental_start_date) {
				if (rental_end_date.data('DateTimePicker').date() === null || rental_start_date.isAfter(rental_end_date.data('DateTimePicker').date())) {
					rental_end_date.data('DateTimePicker').date(rental_start_date.add(1, 'd'));
				}
			}
		});

		// trigger country change
		$('#' + label_name + '-origination_country_id').trigger('change');

		$('#reservationgetinsurancequotes-mytrips_purchasable-1').on('change', function showMytripsClients(event) {
			$('#can-purchase-clients').show();
		});

		$('#reservationgetinsurancequotes-mytrips_purchasable-0').on('change', function hideMytripsClients(event) {
			$('#can-purchase-clients').hide();
		});

		$('#reservationgetinsurancequotes-deposit_paid-1').on('change', function showDepositNotice(event) {
			$('.deposit-paid-notice').removeClass('hidden');
		});

		$('#reservationgetinsurancequotes-deposit_paid-0').on('change', function hideDepositNotice(event) {
			$('.deposit-paid-notice').addClass('hidden');
		});

		function adjustCoverageDates(checkbox)
		{
			var trip_dates         = [];
			var start_date         = null;
			var end_date           = null;
			var purchase_date      = null;
			var checked_components = 0;

			if (checkbox.is(':checked')) {
				$('.include-component').each(function onEachCheckbox(i, elem)
				{
					if (
						$(elem).is(':checked')
						&& $(elem).data('start') !== ''
						&& $(elem).data('end') !== ''
						&& $(elem).data('purchased') !== ''
					) {
						trip_dates.push({
							start_date   : moment($(elem).data('start')),
							end_date     : moment($(elem).data('end')),
							purchase_date: moment($(elem).data('purchased')),
						});
					}
				});

				if (trip_dates.length > 0) {
					start_date    = trip_dates[0].start_date;
					end_date      = trip_dates[0].end_date;
					purchase_date = trip_dates[0].purchase_date;
				}

				$.each(trip_dates, function onEachTripDate(i, date_obj) {
					// find the lowest start date
					if (i > 0 && date_obj.start_date.isBefore(start_date)) {
						start_date = date_obj.start_date;
					}

					// find the greatest end date
					if (i > 0 && date_obj.end_date.isAfter(end_date)) {
						end_date = date_obj.end_date;
					}

					// find the lowest purchase date
					if (i > 0 && date_obj.purchase_date.isBefore(purchase_date)) {
						purchase_date = date_obj.purchase_date;
					}
				});

				$('#' + label_name + '-start_date').data('DateTimePicker')
												   .date(start_date.format('YYYY-MM-DD'));

				$('#' + label_name + '-end_date').data('DateTimePicker')
												 .date(end_date.format('YYYY-MM-DD'));
			} else {
				// clear coverage dates if there are no components checked
				$('.include-component').each(function onEachCheckbox(i, elem)
				{
					if ($(elem).is(':checked')) {
						checked_components++;
					}
				});

				if (checked_components === 0) {
					$('#' + label_name + '-start_date')
						.data('DateTimePicker')
						.clear();

					$('#' + label_name + '-end_date')
						.data('DateTimePicker')
						.clear();
				}
			}
		}

		/**
		 * Set the value of the "Total Trip Cost" input field.
		 * This is set to whatever value "total_trip_cost" has
		 * @return {void}
		 */
		function updateTotalTripCostValue()
		{
			total_trip_field.val(total_trip_cost.toFixed(2));
		}

		function populateStates(states)
		{
			$('#' + label_name + '-state_id')
				.empty()
				.append('<option selected="1"></option>');

			$.each(states, function onEachState(id, state_name) {
				var markup = '';
				markup += '<option value="' + id + '">';
				markup += state_name;
				markup += '</option>';

				$('#' + label_name + '-state_id').append(markup);
			});
		}

		form.confirmation = function confirmation(response)
		{
			var form_name = form.name;
			var $jForm;

			if (response.data.response_code === "missing_deposit_date") {
				Adzuki.CustomConfirm({
					body   : 'The trip initial deposit date was not entered. Therefore, Cancel Anytime policies will not be quoted. Do you wish to continue?',
					confirm: function yes() {
						$jForm = $('form[name="' + form_name + '"]');

						// set hidden input indicating that the user actioned the confirm message, so we do not throw a confirm again
						$jForm.find('.confirm-actioned').val(1);
						$jForm.submit();
					}
				});
			}
		};
	};

}(jQuery, window.Adzuki || {}));
